import { Button } from "@vericus/cadmus-ui";

import { show } from "@ebay/nice-modal-react";

import { useAppSelector } from "@/data/hooks";
import { ReattemptButton } from "@/features/socratic/components/reattempt-button";

import { useDialogueControls } from "../hooks";
import { selectSocraticDialogueState } from "../socratic-slice";
import { StopRecordingConfirmModal } from "./stop-recording-confirm-modal";
import * as styles from "./styles.css";

interface Props {
  hasRecordingPermission: boolean;
  onStartEarlyPressed: () => void;
  onStopEarlyPressed: () => void;
  onRetakePressed: () => void;
  isDialogueCompleted: boolean;
  reattemptDisabled: boolean;
  numAttemptsRemaining: number;
  /** Non-null after a failed upload — retries the same recording. */
  retryUpload: (() => void) | null;
  /** The recorder stopped with an error. */
  recordingFailed: boolean;
}

export function SocraticDialogueControls(props: Props) {
  const {
    onStartEarlyPressed,
    onStopEarlyPressed,
    onRetakePressed,
    isDialogueCompleted,
    reattemptDisabled,
    numAttemptsRemaining,
    hasRecordingPermission,
    retryUpload,
    recordingFailed,
  } = props;
  const dialogueTimeline = useAppSelector(selectSocraticDialogueState);
  const { canStartEarly, canStopEarly, canShowStopEarly } =
    useDialogueControls(dialogueTimeline);

  return (
    <div className={styles.controls}>
      {canStartEarly && hasRecordingPermission && (
        <Button onClick={onStartEarlyPressed} kind="primary">
          Start Recording Early
        </Button>
      )}

      {canShowStopEarly && hasRecordingPermission && !recordingFailed && (
        <Button
          onClick={() => {
            show(StopRecordingConfirmModal, {
              onConfirm: onStopEarlyPressed,
              remainingAttempts: numAttemptsRemaining,
            });
          }}
          kind="secondary"
          disabled={!canStopEarly}
        >
          Stop Recording
        </Button>
      )}

      {retryUpload != null && (
        <Button onClick={retryUpload} kind="primary">
          Retry upload
        </Button>
      )}

      {isDialogueCompleted && (
        <>
          <ReattemptButton
            onPress={onRetakePressed}
            numAttemptsRemaining={numAttemptsRemaining}
            disabled={reattemptDisabled}
          />
        </>
      )}
    </div>
  );
}
